import React, {useEffect, useState} from 'react';
import MailPropertiesList from "./components/MailPropertiesList";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {MailPropertiesApi} from "../../../../modules/mail/api/MailPropertiesApi";
import {MailPropertiesDto} from "../../../../modules/mail/dto/MailPropertiesDto";
import {useIntl} from "react-intl";

const Index: React.FC = () => {
    const intl = useIntl();
    const [mailPropertiesList, setMailPropertiesList] = useState<Array<MailPropertiesDto>>([]);

    useEffect(() => {
        // 查询用户组列表
        fetchMailPropertiesList();
    }, []);

    const fetchMailPropertiesList = async () => {
        const responseResult = await MailPropertiesApi.getMailPropertiesList();
        if (responseResult.status === HttpStatus.SUCCESS) {
            setMailPropertiesList(responseResult.data);
        }
    };

    return (
        <div>
            <MailPropertiesList mailPropertiesList={mailPropertiesList} onRefresh={fetchMailPropertiesList}/>
        </div>
    );
};

export default Index;
